import { Practitioner } from './../../../models/Entities/Practitioners/Practitioner';
import { PractitionerMedicalInsuranceAssociation } from '../../../models/Entities/PractitionerAssociations/MedicalInsurances/PractitionerMedicalInsuranceAssociation';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { IIconProps } from '@fluentui/react';
import { SelectedMedicalInsuranceType } from '../../MedicalInsurance/MedicalInsuranceMultiSelector/MedicalInsuranceMultiSelectorComponent';

//stores
import * as PractitionerMedicalInsuranceAssociationsStore from '../../../redux/middleware/PractitionerMedicalInsuranceAssociationMiddleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';

//#region props

interface IProps {
  PractitionerId: string;
}

interface ConnectedProps {
  practitionerLoadingSuccess: boolean;

  //status
  IsLoading: boolean;
  LoadedSuccessfully: boolean;
  FailOnLoad: boolean;
  ErrorOnLoad: ErrorType;

  IsAssociating: boolean;
  AssociatedSuccessfully: boolean;
  FailOnAssociate: boolean;
  ErrorOnAssociate: ErrorType;

  IsDisassociating: boolean;
  DisassociatedSuccessfully: boolean;
  FailOnDisassociate: boolean;
  ErrorOnDisassociate: ErrorType;

  MedicalInsuranceAssociated: PractitionerMedicalInsuranceAssociation[];
  Practitioners: Practitioner[];
}

interface DispatchProps {
  AssociateMedicalInsuranceToPractitioner: typeof PractitionerMedicalInsuranceAssociationsStore.actionCreators.AssociateMedicalInsuranceToPractitioner;
  DisassociateMedicalInsuranceByMedicalInsuranceId: typeof PractitionerMedicalInsuranceAssociationsStore.actionCreators.DisassociateMedicalInsuranceByMedicalInsuranceId;
  GetMedicalInsuranceByPractitionerId: typeof PractitionerMedicalInsuranceAssociationsStore.actionCreators.GetMedicalInsuranceByPractitionerId;
  GetAllPractitioners: typeof PractitionerStore.actionCreators.GetAllPractitioners;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  MedicalInsuranceAssociated: state.Practitioners?.list.find(
    (practitioner: Practitioner) =>
      practitioner.userId === ownProps.PractitionerId
  )?.MedicalInsuranceAssociated,

  Practitioners: state?.Practitioners?.list,

  practitionerLoadingSuccess: state.Practitioners?.successLoadingAll,

  //load status
  IsLoading: state.PractitionerMedicalInsuranceAssociations?.isLoadingAll,
  LoadedSuccessfully:
    state.PractitionerMedicalInsuranceAssociations?.successLoadingAll,
  FailOnLoad: state.PractitionerMedicalInsuranceAssociations?.failOnLoadingAll,
  ErrorOnLoad: state.PractitionerMedicalInsuranceAssociations?.error,

  // associate status
  IsAssociating: state.PractitionerMedicalInsuranceAssociations?.isAddingNewOne,
  AssociatedSuccessfully:
    state.PractitionerMedicalInsuranceAssociations?.successAddingNewOne,
  FailOnAssociate:
    state.PractitionerMedicalInsuranceAssociations?.failOnAddingNewOne,
  ErrorOnAssociate: state.PractitionerMedicalInsuranceAssociations?.error,

  IsDisassociating:
    state.PractitionerMedicalInsuranceAssociations?.isDeletingOne,
  DisassociatedSuccessfully:
    state.PractitionerMedicalInsuranceAssociations?.successDeletingOne,
  FailOnDisassociate:
    state.PractitionerMedicalInsuranceAssociations?.failOnDeletingOne,
  ErrorOnDisassociate: state.PractitionerMedicalInsuranceAssociations?.error
});

export const mapDispatchToProps = {
  ...PractitionerMedicalInsuranceAssociationsStore.actionCreators,
  ...PractitionerStore.actionCreators
};

//icons
export const AddIcon: IIconProps = { iconName: 'CirclePlus' };

// functions

export function GetSelectedMedicalInsurance(
  MedicalInsurancesSelected: PractitionerMedicalInsuranceAssociation[]
): SelectedMedicalInsuranceType[] {
  return MedicalInsurancesSelected
    ? MedicalInsurancesSelected.map(
        (mi: PractitionerMedicalInsuranceAssociation) => ({
          medicalInsuranceId: mi.medicalInsuranceId,
          ReferenceId: mi.id
        })
      )
    : [];
}
